import application_settings from '../applicationSettings';
import Event from './Event';
import LocalStorage from '../local_data';

class UpdateCheckoutStatus extends Event {
    eventName = 'oms_updateCheckoutStatus';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for update checkout status
     * 
     * @param {string} data.status - checkout status (all_mode, flash_mode)
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';
        let status = data.status;

        if (clientId && status) {

            let checkoutStatus = new LocalStorage.CheckoutStatus(clientId);
            checkoutStatus.setData(status);

            this.onSuccessEvent({
                "auth_type": "public",
                "data": data,
                "data_type": "local",
                "success" : true,
                "message" : ""
            }, {
                'action' : action, 
                'request_id' : requestId 
            });

        } else {
            //fire error event
            this.onErrorEvent({ "message": "client_id & status is required", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }
}

export default UpdateCheckoutStatus;